import { useMyTimesheetFilterState } from "my-timesheet/hooks";

interface DataType {
  rows?: Array<any>; // Replace 'any' with the actual item type if known
}

interface UseMyTimesheetFilterPropertiesProps {
  data?: DataType;
  filterProperties: any; // Replace 'any' with the actual type if known
  setFilterProperties: (props: any) => void; // Adjust type as needed
  type: string;
}

export const useMyTimesheetFilterProperties = ({
  data,
  filterProperties,
  setFilterProperties,
  type,
}: UseMyTimesheetFilterPropertiesProps) => {
  const availableItems = data?.rows || [];

  const { state: filter, setState: handleFilterChange } =
    useMyTimesheetFilterState();

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = { ...filterProperties, search: event.target.value };
    setFilterProperties(newState);
  };

  const handleClearSearch = () => {
    setFilterProperties({ ...filterProperties, search: "" });
  };

  const handleAddItem = (props: { key: string; value: any }) => {
    const { key, value } = props;
    const item = availableItems.find((item) => item.code === value);
    const items = filter[key];
    const newItems = [...items, item.code];
    const newState = { ...filter, [key]: newItems };
    handleFilterChange(newState);
  };

  const selectedItems = availableItems.filter((item) =>
    filter[type].includes(item.code),
  );

  const handleRemoveItem = (props: { key: string; value: any }) => {
    const { key, value } = props;
    const items = filter[key];
    const newItems = items.filter((item: any) => item !== value);
    const newState = { ...filter, [key]: newItems };
    handleFilterChange(newState);
  };

  const handleClickItem = (item: any) => {
    if (selectedItems.find((listItem) => listItem._id === item._id)) {
      handleRemoveItem({
        key: type,
        value: item.code,
      });
    } else {
      handleAddItem({
        key: type,
        value: item.code,
      });
    }
  };

  return {
    availableItems,
    selectedItems,
    handleSearch,
    handleClearSearch,
    handleAddItem,
    handleRemoveItem,
    handleClickItem,
  };
};

export default useMyTimesheetFilterProperties;
